// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";
// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

/**
 * @param {{ params?: object, query: { saleId: string, type?: string, page?: number, limit?: number } }} option
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.SaleDocument.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * @param {{
 *   saleId: string,
 *   title: string,
 *   description?: string,
 *   filePath: string,
 *   type: "Pdf" | "Image" | "Video" | "Other",
 *   fileSize: number
 * }} form
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.SaleDocument.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * @param {{ params: { id: string }, query?: object }} option
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.SaleDocument.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * @param {{
 *   title?: string,
 *   description?: string,
 *   filePath?: string,
 *   type?: "Pdf" | "Image" | "Video" | "Other",
 *   fileSize?: number,
 *   isActive?: boolean
 * }} form
 * @param {{ params: { id: string }, query?: object }} option
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.SaleDocument.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * @param {{ params: { id: string }, query?: object }} option
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.SaleDocument.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
